import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

export default function AchievementForm({ formData, onChange }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
  };

  const characterCount = formData.achievement ? formData.achievement.length : 0;

  return (
    <Box>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        自己実績
      </Typography>

      <TextField
        fullWidth
        multiline
        rows={8}
        id="achievement"
        name="achievement"
        value={formData.achievement || ''}
        onChange={handleChange}
        placeholder="OSSなどのコミット経験等"
        variant="outlined"
        margin="normal"
        helperText={`${characterCount}文字`}
        FormHelperTextProps={{
          sx: {
            textAlign: 'right',
            marginRight: '0',
          },
        }}
        sx={{
          '& textarea:focus': {
            boxShadow: 'none',
          },
        }}
      />
    </Box>
  );
}
